import { apiService } from './api';
import { Smtp, CreateSmtpData, UpdateSmtpData, SmtpProviderOption } from '../types';

class SmtpService {
  async getAllSmtp(): Promise<Smtp[]> {
    const response = await apiService.get('/smtp');
    return response.data;
  }

  async getActiveSmtp(): Promise<Smtp[]> {
    const response = await apiService.get('/smtp/active');
    return response.data;
  }

  async getDefaultSmtp(): Promise<Smtp | null> {
    const response = await apiService.get('/smtp/default');
    return response.data;
  }

  async getSmtpById(id: string): Promise<Smtp> {
    const response = await apiService.get(`/smtp/${id}`);
    return response.data;
  }

  async createSmtp(smtpData: CreateSmtpData): Promise<Smtp> {
    const response = await apiService.post('/smtp', smtpData);
    return response.data;
  }

  async updateSmtp(id: string, smtpData: UpdateSmtpData): Promise<Smtp> {
    const response = await apiService.patch(`/smtp/${id}`, smtpData);
    return response.data;
  }

  async deleteSmtp(id: string): Promise<void> {
    await apiService.delete(`/smtp/${id}`);
  }

  async setDefaultSmtp(id: string): Promise<Smtp> {
    const response = await apiService.patch(`/smtp/${id}/default`);
    return response.data;
  }

  async toggleActiveSmtp(id: string): Promise<Smtp> {
    const response = await apiService.patch(`/smtp/${id}/toggle-active`);
    return response.data;
  }

  async getProviders(): Promise<SmtpProviderOption[]> {
    const response = await apiService.get('/smtp/providers');
    return response.data;
  }
}

export const smtpService = new SmtpService(); 